import React from 'react';
import { Login } from './Login';
import { FirebaseContext } from './firebase/Context';

export class LoginPage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>
                Identif&iacute;quese!
                <FirebaseContext.Consumer>
                    {
                        ({ firebase }) => <Login firebase={firebase} history={this.props.history}>  </Login>
                    }
                </FirebaseContext.Consumer>
            </div>
        );
    }
}